import { shapes, ratios } from 'components/library/Scroller';
import Headline from 'components/library/Headline';

export const UgcHeadline = () => {
  return (
    <Headline
      title={<>Stories from scientists, innovators, and members like you.</>}
      variant='left'
    />
  );
};

export const items = [
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1752249339/library/scroller/Frame_1739333317.png',
      width: 524,
      height: 860,
      alt: 'ds01 on bathroom sink',
    },
    shape: 'round' as shapes,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1753371915/library/scroller/Frame_1739333315.png',
      width: 552,
      height: 860,
      alt: 'dispensing two seed pills',
    },
    shape: 'vertical' as shapes,
  },
  {
    video: {
      playbackId: 'B7ii9VEdNofKFscQjX1KWamismdYkNjaHKZEfC5zADE',
      devPlaybackId: 'X02cIUhTn899QdOBqiUoc44PLW9I1PgO7HgkI7Hwo6QU',
      format: 'mp4',
    },
    ratio: '9:14' as ratios,
    shape: 'vertical' as shapes,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1752252570/library/scroller/Frame_1739333318.png',
      width: 552,
      height: 860,
      alt: 'ds-01 on a counter',
    },
    shape: 'horizontal-pill' as shapes,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1753366891/library/scroller/ugc-5.png',
      width: 552,
      height: 860,
      alt: 'quote from fast company',
    },
    url: 'https://www.fastcompany.com/90813751/this-company-is-sending-plastic-eating-microbes-into-space',
    shape: 'horizontal' as shapes,
  },

  {
    video: {
      playbackId: 'ulw3ww5UZIgdyYqXJgZq1rqt4GxjG631zzxeGLdN9Co',
      devPlaybackId: 'RLZOmOM7ozom02ekPi3tw7U6dUFJ5A9cfu0002ErlRvouo',
      format: 'mov',
    },
    ratio: '9:14' as ratios,
    shape: 'vertical' as shapes,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1752261552/library/scroller/Frame_1739333320.png',
      width: 552,
      height: 860,
      alt: 'woman wearing seed merchandise',
    },
    shape: 'vertical' as shapes,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1753366892/library/scroller/ugc-8.png',
      width: 552,
      height: 860,
      alt: 'quote from forbes',
    },
    url: 'https://www.forbes.com/sites/oliviaobryon/2022/11/06/how-can-microbes-support-wellness-and-save-the-planet-seed-health-co-founders-explain/',
    shape: 'horizontal' as shapes,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1752252937/library/scroller/blobs.png',
      width: 552,
      height: 860,
      alt: 'clip 5',
    },
    shape: 'horizontal-pill' as shapes,
  },
];

export const itemsDouble = [
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887581/library/double-scroller/clip-1-1.jpg',
      width: 524,
      height: 860,
      alt: 'clip 1',
    },
    ratio: '9:14' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887588/library/double-scroller/clip-1-2.jpg',
      width: 552,
      height: 864,
      alt: 'clip 2',
    },
    ratio: '14:9' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/double-scroller/clip-1-3.jpg',
      width: 552,
      height: 860,
      alt: 'clip 3',
    },
    ratio: '1:1' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887581/library/double-scroller/clip-1-4.jpg',
      width: 552,
      height: 860,
      alt: 'clip 4',
    },
    url: 'https://seed.com/',
    ratio: '9:14' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/double-scroller/clip-1-5.jpg',
      width: 552,
      height: 860,
      alt: 'clip 5',
    },
    ratio: '14:9' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887585/library/double-scroller/clip-1-6.jpg',
      width: 552,
      height: 860,
      alt: 'clip 6',
    },
    ratio: '9:14' as ratios,
  },
  {
    video: {
      src: 'https://res.cloudinary.com/dljz0lko8/video/upload/f_auto,q_auto/v1748887695/library/scroller/video-placeholder.mp4',
      format: 'mp4',
    },
    ratio: '9:14' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887588/library/double-scroller/clip-1-2.jpg',
      width: 552,
      height: 864,
      alt: 'clip 2',
    },
    ratio: '14:9' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/double-scroller/clip-1-3.jpg',
      width: 552,
      height: 860,
      alt: 'clip 3',
    },
    ratio: '1:1' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887581/library/double-scroller/clip-1-4.jpg',
      width: 552,
      height: 860,
      alt: 'clip 4',
    },
    ratio: '9:14' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/double-scroller/clip-1-5.jpg',
      width: 552,
      height: 860,
      alt: 'clip 5',
    },
    url: 'https://seed.com/',
    ratio: '14:9' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887585/library/double-scroller/clip-1-6.jpg',
      width: 552,
      height: 860,
      alt: 'clip 6',
    },
    ratio: '9:14' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/double-scroller/clip-2-1.jpg',
      width: 524,
      height: 860,
      alt: 'clip 1',
    },
    ratio: '9:14' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887651/library/double-scroller/clip-2-2.jpg',
      width: 552,
      height: 864,
      alt: 'clip 2',
    },
    ratio: '14:9' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/double-scroller/clip-2-3.jpg',
      width: 552,
      height: 860,
      alt: 'clip 3',
    },
    ratio: '1:1' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887655/library/double-scroller/clip-2-4.jpg',
      width: 552,
      height: 860,
      alt: 'clip 4',
    },
    ratio: '9:14' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/double-scroller/clip-1-3.jpg',
      width: 552,
      height: 860,
      alt: 'clip 5',
    },
    url: 'https://seed.com/',
    ratio: '14:9' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887656/library/double-scroller/clip-2-5.jpg',
      width: 552,
      height: 860,
      alt: 'clip 6',
    },
    ratio: '9:14' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/double-scroller/clip-2-1.jpg',
      width: 524,
      height: 860,
      alt: 'clip 1',
    },
    ratio: '9:14' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887651/library/double-scroller/clip-2-2.jpg',
      width: 552,
      height: 864,
      alt: 'clip 2',
    },
    ratio: '14:9' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/double-scroller/clip-2-3.jpg',
      width: 552,
      height: 860,
      alt: 'clip 3',
    },
    ratio: '1:1' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887655/library/double-scroller/clip-2-4.jpg',
      width: 552,
      height: 860,
      alt: 'clip 4',
    },
    ratio: '9:14' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887589/library/double-scroller/clip-1-3.jpg',
      width: 552,
      height: 860,
      alt: 'clip 5',
    },
    ratio: '14:9' as ratios,
  },
  {
    cover: {
      src: 'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1748887656/library/double-scroller/clip-2-5.jpg',
      width: 552,
      height: 860,
      alt: 'clip 6',
    },
    ratio: '9:14' as ratios,
  },
];
